type CallbackFunction = (newValue: any) => void;

/**
 * @name observePropertySetter
 *
 * @description intercepts property setters and triggers a passed in callback function on every change
 *
 * @example
 * observePropertySetter(inputEl, 'value', (newValue: any) => {
 *   console.log('value changed to ' + newValue);
 * });
 */
export const observePropertySetter = (object: unknown, propertyName: string, callbackFn: CallbackFunction): void => {
  const prototype = Object.getPrototypeOf(object);
  const descriptor = Object.getOwnPropertyDescriptor(prototype, propertyName);
  const originalSetter = descriptor.set;

  Object.defineProperty(object, propertyName, {
    ...descriptor,
    set: function (value: any) {
      const appliedValue = originalSetter.apply(object, [value]);
      callbackFn(value);
      return appliedValue;
    },
  });
};
